(function () {
  'use strict';

  /* @ngdoc object
   * @name crewSalesReport
   * @description
   *
   */
  angular
    .module('crewSalesReport', [
      'ui.router'
    ]);
}());
